<template>
	<div
		@click="goTo('Tag', { tag: tag.slug })"
		class="tag gradient"
		:style="'background-image: url(' + tag.taxonomy_and_category_image_data.large + ')'"
	>
		<div class="header">
			<div class="aili-pink--text font-size-12">PLAYLIST SENZA LATTOSIO</div>
			<div class="font-size-14">
				{{ tag.name }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['tag'],
};
</script>

<style lang="scss" scoped>
.header {
	position: absolute;
	bottom: $spacing-0;
	left: $spacing-0;
	color: #fff;
}
</style>
